module.exports = __webpack_public_path__ + "static/media/postcard.9c235281.jpg";